export const studyCalculators = [
  {
    name: "Tabel Konversi IPK",
    link: "/calculator/id/gpatableconverter/",
    description:
      "Kalkulator ini membantu mengkonversi IPK mahasiswa ke berbagai skala seperti IPK dan sistem persentase dan lainnya.",
    showMain: true,
  },
  {
    name: "Kalkulator IPK Universitas (Kumulatif)",
    link: "/calculator/id/gpagrade/",
    description:
      "Kalkulator ini menghitung IPK universitas berdasarkan sistem studi internasional.",
    showMain: true,
  },
  {
    name: "Kalkulator IPK Skala 4",
    link: "/calculator/id/gpa4/",
    description:
      "Kalkulator ini digunakan untuk menghitung IPK berdasarkan sistem penilaian skala 4 poin.",
    showMain: true,
  },
  {
    name: "Kalkulator IPK Skala 5",
    link: "/calculator/id/gpa5/",
    description:
      "Kalkulator ini menghitung IPK berdasarkan sistem penilaian skala 5 poin.",
    showMain: true,
  },
  {
    name: "Kalkulator Nilai Skala 100",
    link: "/calculator/id/grade100/",
    description:
      "Kalkulator ini mengkonversi nilai dari sistem penilaian ke sistem perseratus.",
    showMain: true,
  },
  {
    name: "Kalkulator Perencanaan IPK",
    link: "/calculator/id/gpaplanner/",
    description:
      "Kalkulator ini digunakan untuk merencanakan IPK masa depan berdasarkan nilai yang diharapkan.",
    showMain: true,
  },
  {
    name: "Konversi Nilai 100 ke 4 dan Sebaliknya",
    link: "/calculator/id/grade100to4/",
    description:
      "Kalkulator ini membantu mengkonversi nilai dari sistem perseratus ke sistem penilaian skala 4 poin dan sebaliknya.",
  },
  {
    name: "Konversi IPK 4 ke 5 dan Sebaliknya",
    link: "/calculator/id/gpa4to5/",
    description:
      "Kalkulator ini digunakan untuk mengkonversi IPK antara sistem penilaian skala 4 poin dan 5 poin.",
  },
  {
    name: "Konversi IPK 5 ke 100",
    link: "/calculator/id/grade100to5/",
    description:
      "Konversi IPK dengan mudah antara sistem 5 poin dan sistem perseratus. Pelajari cara mengkonversi IPK dari 5 ke 100 dan sebaliknya menggunakan alat sederhana ini.",
  },
  {
    name: "Kalkulator Nilai Ujian",
    link: "/calculator/id/test-grade/",
    description: "Hitung persentase dan nilai ujian Anda dengan mudah menggunakan kalkulator nilai.",
  },
  {
    name: "Konversi IPK ke Sistem Inggris",
    link: "/calculator/id/gradetouk/",
    description:
      "Kalkulator ini mengkonversi IPK ke sistem penilaian Inggris.",
    showMain: true,
  },
  {
    name: "Konversi IPK ke Sistem Jerman",
    link: "/calculator/id/gradetogerman/",
    description:
      "Konversi IPK Anda ke sistem Jerman dengan mudah dan akurat. Pelajari cara mengkonversi nilai sarjana dan magister ke sistem Jerman menggunakan alat yang berguna ini.",
  },
  {
    name: "Konversi IPK ke Sistem Prancis",
    link: "/calculator/id/gradetofrench/",
    description:
      "Temukan cara mengkonversi IPK Anda ke sistem Prancis dengan mudah dan akurat. Pelajari detail sistem penilaian universitas Prancis.",
  },
  {
    name: "Konversi IPK ke Sistem Kanada",
    link: "/calculator/id/gradetocanada/",
    description:
      "Temukan cara mengkonversi IPK Anda ke sistem Kanada dengan mudah dan akurat. Pelajari detail sistem penilaian universitas Kanada.",
  },
  {
    name: "Konversi IPK ke Sistem Penilaian Malaysia",
    link: "/calculator/id/gradetomalaysia/",
    description:
      "Pelajari cara mengkonversi IPK Anda ke sistem penilaian Malaysia dengan mudah dan akurat. Pelajari sistem penilaian di universitas Malaysia.",
  },
  {
    name: "Konversi IPK ke Sistem Turki",
    link: "/calculator/id/gradetoturkey/",
    description:
      "Temukan cara mengkonversi IPK Anda ke sistem Turki dengan mudah dan akurat. Pelajari detail sistem penilaian universitas Turki.",
  },
  {
    name: "Konversi IPK ke Sistem Australia",
    link: "/calculator/id/gradetoaustralia/",
    description:
      "Temukan cara mengkonversi IPK Anda ke sistem Australia dengan mudah dan akurat. Pelajari detail sistem penilaian universitas Australia.",
  },
  {
    name: "Kalkulator Persentase Tertimbang",
    link: "/calculator/id/weighted-percentage-calculator/",
    description:
      "Kalkulator untuk menghitung persentase tertimbang berdasarkan IPK, nilai kemampuan, dan pencapaian.",
  },
];
export default studyCalculators;